import { useEffect } from "react";

import AddClientProviderModal from "../../../../../cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/AddClientProviderModal";
import { STRINGS } from "../../config/strings";
import { useProviderSearchStore } from "../../store/providerSearchStore";

export default function ProviderMapPageWrapper({ isProviderMapPage = true }) {
  const { setIsProviderMapPage, reset, setInitAddress, setShowCustomSearch } =
    useProviderSearchStore();
  useEffect(() => {
    reset();
    setIsProviderMapPage(isProviderMapPage);
    if (isProviderMapPage) {
      setInitAddress(STRINGS.DEFAULT_INIT_ADDRESS);
      setShowCustomSearch(true);
    }
  }, [isProviderMapPage]);

  return <AddClientProviderModal isAddProviderModal={false} />;
}
